import { toNumber } from '../../../utils/numberUtils.js'
export { calcularProrrateoReciproco } from '../prorrateoReciproco.js'

export function resolverCriterioDocenteMixto(expediente = {}, rows = []) {
  const servicios = Array.isArray(expediente?.prorrateoServicios) ? expediente.prorrateoServicios : []
  const aniosDocentesManual = servicios
    .filter((s) => String(s?.regimen || '').toUpperCase().includes('DOC'))
    .reduce((acc, s) => acc + toNumber(s?.anios), 0)
  const aniosComunesManual = servicios
    .filter((s) => !String(s?.regimen || '').toUpperCase().includes('DOC'))
    .reduce((acc, s) => acc + toNumber(s?.anios), 0)

  const aniosDocentesRows = (Array.isArray(rows) ? rows : []).filter((r) => {
    const tag = String(r?.tipoActividad || r?.tipo || r?.tipoRaw || '').toLowerCase()
    return tag.includes('docente') || tag.includes('profesor') || tag.includes('maestra')
  }).length / 12

  const aniosDocentes = Number((aniosDocentesManual > 0 ? aniosDocentesManual : aniosDocentesRows).toFixed(2))
  const aniosComunes = Number((aniosComunesManual > 0 ? aniosComunesManual : Math.max(0, ((Array.isArray(rows) ? rows.length : 0) / 12) - aniosDocentes)).toFixed(2))

  if (aniosDocentes >= 25) {
    return {
      cajaOtorgante: 'REGIMEN_ESPECIAL_DOCENTE',
      explicacionJuridica: 'Posee el minimo de servicios especiales. Absorbe los servicios comunes y liquida al 82% movil (Dec. 137/05).',
      movilidadAsignada: 'RIPDOC',
      applyDocenteFormula: true,
      aniosDocentes,
      aniosComunes,
    }
  }

  return {
    cajaOtorgante: 'REGIMEN_GENERAL_SIPA',
    explicacionJuridica: 'Servicios docentes insuficientes para regimen puro. Se aplica prorrateo de edad (Art. 18 Dec. 433/94) y el haber se compone por PBU+PC+PAP.',
    movilidadAsignada: 'IPC_GENERAL',
    applyDocenteFormula: false,
    aniosDocentes,
    aniosComunes,
  }
}
